<template>
  <b-modal ref="add-supplier" hide-footer title="Nouveau fournisseur">
    <div class="d-block text-center">
      <b-container fluid>
        <b-form @submit="onSubmit">
                    <b-form-group
                        id="loopName"
                        label="Nom"
                        label-for="loopInputName">
                        <b-form-input
                        id="loopInputName"
                        type="text"
                        v-model="supplier"
                        required
                        placeholder="Fournisseur"
                        />
                    </b-form-group>
                     <b-button @click="checkInSage()" v-if="!sageChecked" variant="primary">Ckeck in ERP</b-button>
                    <b-form-group
                        v-if="sageChecked"
                        id="loopDescription"
                        label="Description"
                        label-for="loopDescription1">
                        <b-form-input
                        id="loopDescription1"
                        type="text"
                        v-model="supplier_code"
                        required
                        placeholder="Code Fournisseur"
                        />
                    </b-form-group>
                    <b-button v-if="sageChecked" type="submit" variant="primary">Créer</b-button>
                </b-form>
        <b-row>
          <b-col sm="5">
            <b-button
              class="mt-3"
              variant="outline-danger"
              block
              @click="hideModal()"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'
import erpLoaderServer from '../../api/erp_loader_server.vue'

export default {
  name: 'AddSupplier',
  props: [],
  data() {
    return {
      supplier: "",
      supplier_code: "",
      sageChecked: false
    }
  },
  methods: {
    hideModal () {
      this.$refs['add-supplier'].hide()
    },
    checkInSage() {
        erpLoaderServer.getSupplier(this.supplier, process.env.STORE).then((result) => {
          this.supplier_code = result.data.supplier_code
          this.sageChecked = true

      })
    },
    showModal () {
      this.$refs['add-supplier'].show()
    },
     onSubmit(evt) {
        evt.preventDefault()
        server.addSupplier({'supplier': this.supplier ,'supplier_code': this.supplier_code}).then(() => {
            this.makeToast("MaJ réussie !")
            window.location.reload()
            this.hideModal()

        })
      },
      onReset(evt) {
        evt.preventDefault()
        /* Reset our form values */
        this.resetValues()
        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => {
            this.show = true
        })
      },
      resetValues () {
          this.supplier = ""
          this.supplier_code = ""
      }
  },
  mounted: function() {
  },
  components: { }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/supply/AddSupplierModal.vue